module.exports = __webpack_public_path__ + "static_pc/img/23.026a2b9b.png";